export default {
  sds: 'SDS',
  pt: 'PT',
  inactiveSDS: 'inactiveSDS',
  inactivePT: 'inactivePT'
};
